import { render, staticRenderFns } from "./AddUsuario.vue?vue&type=template&id=1ac4dbe0"
import script from "./AddUsuario.vue?vue&type=script&lang=js"
export * from "./AddUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports